// extracted by mini-css-extract-plugin
module.exports = {"desktop":"(min-width: 1024px)","page":"userGroupPage_page__2KIj0","nestedPages":"userGroupPage_nestedPages__41fVv"};